import React, { CSSProperties } from 'react';

type Props = {
  style?: CSSProperties;
  fill?: string;
  width?: string | number;
  className?: string;
  viewBox?: string;
};

const SVG: React.FC<Props> = ({
  style = {},
  fill = '#000',
  width = '100%',
  className = '',
  viewBox = '0 0 3.33 2.33',
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g id="Camada_2" data-name="Camada 2">
      <g id="Layer_2" data-name="Layer 2">
        <path
          fill={fill}
          d="M.35.84H.22A.26.26,0,0,1,0,.56V.1A.06.06,0,0,1,.06,0,.06.06,0,0,1,.12.1V.56c0,.09.05.16.1.16H.35S.45.65.45.56V.1A.05.05,0,0,1,.51,0,.06.06,0,0,1,.57.1V.56A.26.26,0,0,1,.35.84Z"
        />
        <path
          fill={fill}
          d="M.28,2.33a.06.06,0,0,1-.06-.06V.1A.06.06,0,0,1,.28,0,.05.05,0,0,1,.34.1V2.27A.05.05,0,0,1,.28,2.33Z"
        />
        <path
          fill={fill}
          d="M1.61,1.91a.72.72,0,0,1-.72-.73.73.73,0,1,1,.72.73Zm0-1.33a.61.61,0,1,0,.61.6A.6.6,0,0,0,1.61.58Z"
        />
        <path
          fill={fill}
          d="M1.61,2.22a1,1,0,1,1,1-1A1,1,0,0,1,1.61,2.22Zm0-1.95a.92.92,0,1,0,.92.91A.91.91,0,0,0,1.61.27Z"
        />
        <path
          fill={fill}
          d="M3.27,2.33a.06.06,0,0,1-.06-.06V1.51H2.87a.06.06,0,0,1-.06-.06v-1A.47.47,0,0,1,3.27,0l0,0s0,0,0,0V2.27A.05.05,0,0,1,3.27,2.33Zm-.34-.94h.28V.13a.33.33,0,0,0-.28.34Z"
        />
      </g>
    </g>
  </svg>
);

export default SVG;
